























































































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Icon from '../../../../components/Icon/Icon.vue';
import LanguagePicker from '../../../../components/LanguagePicker.vue'
import { MenuButton, MenuItems } from "../../NewConfig";
import TemplateContext from '../../includes/TemplateContext'
import { i18nHelper } from "../../includes/logic/i18nHelper";
import { SearchBarItem } from '../../includes/types/Config'
import CustomDropdownItem from '../CustomDropdownItem.vue'
import SearchPanel from '../SearchPanel.vue'
import UserMeta from '../UserMeta.vue'

@Component({
  components: {
    LanguagePicker,
    UserMeta,
    SearchPanel,
    CustomDropdownItem,
    Icon
  },
})
export default class LayoutHeader extends Vue {
  @Prop({ type: Boolean, required: true }) sidebarCollapsed!: boolean

  @Prop({ type: Array, required: true }) navItems!: MenuItems

  @Emit('triggerClick')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  triggerClick(): void {
  }

  @Emit()
  languageUpdated(lang: string) {
    return lang
  }

  showFullSearch = false

  templateContext = new TemplateContext(this.$route)

  get entities(): Array<SearchBarItem> | Promise<Array<SearchBarItem>> | null {
    if (this.$store.state.AdminTemplate.applicationConfig.search) {
      return this.$store.state.AdminTemplate.applicationConfig.search.entities(this.templateContext)
    }

    return null
  }

  get isSearchbarActive(): boolean {
    return this.$store.state.AdminTemplate.applicationConfig?.search !== undefined
  }

  get languageCodes(): Array<string> {
    return this.$store.state.AdminTemplate.applicationConfig.meta.languageCodes
  }

  buttonClickHandler(item: MenuButton): void {
    if (item.onClick) {
      item.onClick(this.templateContext)
    }

    if (item.route) {
      this.$router.push(item.route)
    }

    if (item.href) {
      window.location.href = item.href
    }
  }

  updateLocale(locale: string): void {
    i18nHelper.setLocale(this.$i18n, locale)

    this.languageUpdated(locale)
  }

  created():void {
    this.$i18n.mergeLocaleMessage('ru', {
      close_sidebar: 'Закрыть меню',
      open_sidebar: 'Открыть меню',
    })
    this.$i18n.mergeLocaleMessage('en', {
      close_sidebar: 'Close menu',
      open_sidebar: 'Open menu',
    })

  }
}
